exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n    padding-top: 100px;\n    padding-bottom: 100px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/admin/admin-signin/admin-signin.component.css
// module id = ../../../../../src/app/admin/admin-signin/admin-signin.component.css
// module chunks = main